import PropTypes from 'prop-types';
import React from 'react';


const AuthorityItem = ({
    index,
    title,
    total,
}) => {

    return (
        <h3 className={`type-style-3 py-30 ${index === total-1 ? '' : 'border-b border-b-charcoal'} sm:border-b sm:border-b-charcoal`}>
            {title}
        </h3>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

const propTypes = {
    index: PropTypes.number,
    title: PropTypes.string,
    total: PropTypes.number,
};

AuthorityItem.propTypes = propTypes;

export default AuthorityItem;
